import Checkbox from './CheckboxAdapter';
export { Checkbox as default };
